<div class="songs"
     [class.list]="view() === 'list'"
     [class.numbered]="numbered()"
     data-testid="recueil-list">

  @for (lyric of items(); track lyric.id) {
    <ls-lyric-card
      [lyric]="lyric"
      [href]="lyricHref(lyric)"
      [rankStyle]="showNo() ? (numbered() ? 'badge' : 'plain') : 'none'"
      [showPlayOverlay]="true"
      [showArtist]="true"
      [showSigle]="true"
      trailingAction="menu"
      [showOpenLyrics]="true"
      [showListenNow]="true"
      [showPlayNext]="true"
      [showAddToPlaylist]="true"
      [showFavorite]="false"
      [showShare]="true"
      [showContributor]="showContributor()"
      [attr.data-testid]="'song-row-' + lyric.id" />
  }

  @if (loading()) {
    @for (sk of [1, 2, 3, 4]; track sk) {
      <div class="song sk" aria-hidden="true">
        <span class="sk-box sk-no"></span>
        <span class="sk-box sk-cover"></span>
        <span class="sk-body">
          <span class="sk-box sk-ti"></span>
          <span class="sk-box sk-by"></span>
        </span>
      </div>
    }
  }

  @if (!items().length && !loading()) {
    <div class="empty" data-testid="empty-state">Aucun chant ne correspond à vos critères.</div>
  }

</div>
